import { Drawer, DrawerProps } from "@chakra-ui/react";
import React from "react";
import { useIntercom } from "react-use-intercom";
import { Except } from "type-fest";

/**
 * App-specific drawer which replaces the Chakra Drawer.
 *
 * Its only function is to resolve the issue where the default enabled
 * `trapFocus`, steals focus from the Intercom widget when it is open.
 * When `trapFocus` is true, Chakra will forcibly pull focus from anything
 * outside the modal (i.e. the intercom widget).
 */
export function AppDrawer(
  props: Except<DrawerProps, "trapFocus" | "useInert">,
) {
  // Disable the trapFocus feature only when the intercom widget is open.
  // We could just disable trapFocus all the time, but when trapFocus is
  // disabled, it allows the user to navigate and interact outside the modal
  // (e.g. using keyboard navigation), which we want to prevent as much as
  // practical.
  const { isOpen: isIntercomOpen } = useIntercom();

  return (
    <Drawer {...props} trapFocus={!isIntercomOpen} useInert={!isIntercomOpen} />
  );
}
